import './App.css';
import Games from './Games';
import React, {Component, useEffect} from 'react';
import {BrowserRouter as Router, NavLink, Route, Routes, useNavigate, useParams} from 'react-router-dom'

import Publishers from "./Publishers";
import Login from "./Login";
import Register from "./Register";
import CreateCompany from "./CreateCompany";
import CreateGame from "./CreateGame";
import ManageGame from "./ManageGame";
import ManageCompany from "./ManageCompany";
import UpdateCompany from "./UpdateCompany";
import ModeratorGames from "./Moderator/ModeratorGames";
import ModeratorGameReview from "./Moderator/ModeratorGameReview";
import Game from "./Game";
import Company from "./Company";
import AdminHome from "./Admin/AdminHome";
import ManageAccount from "./Account/ManageAccount";
import ConfirmEmail from "./Account/ConfirmEmail";
import ForgotPassword from "./Account/ForgotPassword";
import ConfirmNewPassword from "./Account/ConfirmNewPassword";
import Customer from "./Customers/Customer";
import SearchCustomers from "./Customers/SearchCustomers";
import SearchGame from "./SearchGame";
import Payments from "./Account/Payments/Payments";
import Genres from "./Genres";
import Genre from "./Genre";
import Category from "./Category";
import Categories from "./Categories";
import ModeratorActivity from "./Moderator/ModeratorActivity";
import PublisherGameActivity from "./Moderator/PublisherGameActivity";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import AdminPayouts from "./Admin/AdminPayouts";
import AdminPayout from "./Admin/AdminPayout";
import CompanyRevenue from "./Admin/CompanyRevenue";
import Logout from "./Logout";
import DeveloperConsole from "./Account/Publisher/DeveloperConsole";
import ESHome from "./ESHome";
import AdminSettings from "./Admin/AdminSettings";
import ESHomeNew from "./ESHomeNew";
import CategoriesNew from "./CategoriesNew";
import GenresNew from "./GenresNew";
import Contacts from "./Contacts";
window.__DEV__ = true;

function Home() {
    const navigate = useNavigate();

    const handleSearch = (e) =>{
        e.preventDefault();
        navigate('/games/search/'+e.target.search.value)
    };

    return (
        <div>
            <Routes>
                <Route path="/games" element={<GamesIndex/>} />
                <Route path="/genres" element={<Genres/>} />
                <Route path="/categories" element={<Categories/>} />
                <Route path="/publishers" element={<PublishersIndex/>} />
                <Route path="/account" element={<AccountIndex/>} />
                <Route path="/customers" element={<SearchCustomersIndex/>} />
            </Routes>
            <ESHomeNew/>
        </div>
    );
}
Home.path = "";
Home.navigationOptions = {
    title: "Home",
    linkName: "Home"
};

function PublishersIndex() {
    return (
        <div>
            <Publishers/>
        </div>
    );
}
PublishersIndex.path = "publishers";
PublishersIndex.navigationOptions = {
    title: "Publishers",
    linkName: "Publishers"
};

function SearchCustomersIndex() {
    return (
        <div>
            <h1>Search</h1>
            <SearchCustomers/>
        </div>
    );
}
SearchCustomersIndex.path = "customers-search";
PublishersIndex.navigationOptions = {
    title: "CustomersSearch",
    linkName: "CustomersSearch"
};

function AccountIndex() {
    return (
        <div>
            <Login/>
        </div>
    );
}
AccountIndex.path = "account";
AccountIndex.navigationOptions = {
    title: "Account",
    linkName: "Account"
};

function LoginIndex() {
    return (
        <div>
            <Login/>
        </div>
    );
}
LoginIndex.path = "login";
LoginIndex.navigationOptions = {
    title: "Login",
    linkName: "Login"
};

function RegisterIndex() {
    return (
        <div>
            <Register/>
        </div>
    );
}
RegisterIndex.path = "register";
RegisterIndex.navigationOptions = {
    title: "Register",
    linkName: "Register"
};

function GamesIndex() {
    return (
        <div>
            <Games/>
        </div>
    );
}
GamesIndex.path = "games";
GamesIndex.navigationOptions = {
    title: "Games",
    linkName: "Games"
};

function RegisterCompany() {
    let {userId} = useParams();

    return (
        <div>
            <CreateCompany userId={userId}/>
        </div>
    );
}

function CreateGameIndex() {
    let {companyId} = useParams();

    return (
        <div>
            <CreateGame companyId={companyId}/>
        </div>
    );
}

function GameIndex() {
    let {gameId} = useParams();

    return (
        <div>
            <Game gameId={gameId}/>
        </div>
    );
}

function CompanyIndex() {
    let {companyId} = useParams();

    return (
        <div>
            <Company companyId={companyId}/>
        </div>
    );
}

function PublisherGameIndex() {
    let {gameId, companyId} = useParams();

    return (
        <div>
            <ManageGame gameId={gameId} companyId={companyId}/>
        </div>
    );
}

function ManageCompanyIndex() {
    let {companyId} = useParams();
    console.log(JSON.stringify(companyId));

    return (
        <div>
            <ManageCompany companyId={companyId}/>
        </div>
    );
}

function UpdateCompanyIndex() {
    let {companyId} = useParams();
    console.log(JSON.stringify(companyId));

    return (
        <div>
            <UpdateCompany companyId={companyId}/>
        </div>
    );
}


function ModeratorIndex() {
    return (
        <div>
            <ModeratorGames/>
        </div>
    );
}

function ModeratorGameIndex() {
    let {gameId, moderatorId} = useParams();
    console.log(JSON.stringify(gameId));

    return (
        <div>
            <ModeratorGameReview gameId={gameId} moderatorId={moderatorId}/>
        </div>
    );
}

function PublisherGameActivityIndex() {
    let {gameId, companyId} = useParams();
    console.log(JSON.stringify(gameId));

    return (
        <div>
            <PublisherGameActivity gameId={gameId} companyId={companyId}/>
        </div>
    );
}

function ModeratorActivityIndex() {
    let {moderatorId} = useParams();
    console.log(JSON.stringify(moderatorId));

    return (
        <div>
            <ModeratorActivity moderatorId={moderatorId}/>
        </div>
    );
}

function ConfirmEmailIndex() {
    let {email, token} = useParams();

    return (
        <div>
            <ConfirmEmail email={email} token={token}/>
        </div>
    );
}

function ConfirmNewPasswordIndex() {
    let {email, token, newPassword} = useParams();

    return (
        <div>
            <ConfirmNewPassword email={email} newPassword={newPassword} token={token}/>
        </div>
    );
}

function CustomerIndex() {
    let {userId} = useParams();

    return (
        <div>
            <Customer userId={userId}/>
        </div>
    );
}

function PaymentsIndex() {
    let {userId} = useParams();

    return (
        <div>
            <Payments userId={userId}/>
        </div>
    );
}

function SearchResultIndex() {
    let {search} = useParams();

    return (
        <div>
            <SearchGame search={search}/>
        </div>
    );
}

function GenreIndex() {
    let {genre} = useParams();

    return (
        <div>
            <Genre genre={genre}/>
        </div>
    );
}

function CategoryIndex() {
    let {categoryId} = useParams();

    return (
        <div>
            <Category categoryId={categoryId}/>
        </div>
    );
}

function AdminPayoutIndex() {
    let {payoutId} = useParams();

    return (
        <div>
            <AdminPayout payoutId={payoutId}/>
        </div>
    );
}

function AdminSettingsIndex() {
    let {adminId} = useParams();

    return (
        <div>
            <AdminSettings adminId={adminId}/>
        </div>
    );
}

function LogoutIndex() {
    return (
        <div>
            <Logout/>
        </div>
    );
}

function DeveloperConsoleIndex() {
    return (
        <div>
            <DeveloperConsole/>
        </div>
    );
}

function AdminHomeIndex() {
    return (
        <div>
            <AdminHome/>
        </div>
    );
}

const App = () => {
    return (
        <Router>
            <Header/>

            <Routes>
                <Route exact path="/" element={<Home/>}/>
                <Route exact path="/games" element={<GamesIndex/>}/>
                <Route exact path="/genres" element={<GenresNew/>}/>
                <Route exact path="/genres/:genre" element={<GenreIndex/>}/>
                <Route exact path="/categories" element={<CategoriesNew/>}/>
                <Route exact path="/categories/:categoryId" element={<CategoryIndex/>}/>
                <Route exact path="/games/search/:search" element={<SearchResultIndex/>}/>
                <Route exact path="/games/:gameId" element={<GameIndex/>}/>
                <Route exact path="/publishers" element={<PublishersIndex/>}/>
                <Route exact path="/publishers/:companyId" element={<CompanyIndex/>}/>
                <Route exact path="/account" element={<AccountIndex/>}/>
                <Route exact path="/login" element={<LoginIndex/>}/>
                <Route exact path="/logout" element={<LogoutIndex/>}/>
                <Route exact path="/register" element={<RegisterIndex/>}/>
                <Route exact path="/customer/:userId" element={<CustomerIndex/>}/>
                <Route exact path="/search-customers" element={<SearchCustomersIndex/>}/>
                <Route exact path="/account/:userId/register-company" element={<RegisterCompany/>}/>
                <Route exact path="/account/manage" element={<ManageAccount/>}/>
                <Route exact path="/account/change-password" element={<ForgotPassword/>}/>
                <Route exact path="/account/company/:companyId/game/create" element={<CreateGameIndex/>}/>
                <Route exact path="/account/:userId/payment" element={<PaymentsIndex/>}/>
                <Route exact path="/account/company/:companyId" element={<ManageCompanyIndex/>}/>
                <Route exact path="/account/company/:companyId/update" element={<UpdateCompanyIndex/>}/>
                <Route exact path="/account/company/:companyId/game/:gameId" element={<PublisherGameIndex/>}/>
                <Route exact path="/company/:companyId/game/:gameId/actions" element={<PublisherGameActivityIndex/>}/>
                <Route exact path="/account/confirm-email/:email/:token" element={<ConfirmEmailIndex/>}/>
                <Route exact path="/account/confirm-new-password/:email/:newPassword/:token" element={<ConfirmNewPasswordIndex/>}/>
                <Route exact path="/moderator" element={<ModeratorIndex/>}/>
                <Route exact path="/moderator/:moderatorId" element={<ModeratorActivityIndex/>}/>
                <Route exact path="/moderator/:moderatorId/game/:gameId" element={<ModeratorGameIndex/>}/>
                <Route exact path="/admin" element={<AdminHomeIndex/>}/>
                <Route exact path="/admin/:adminId/settings" element={<AdminSettingsIndex/>}/>
                <Route exact path="/admin/company-revenue" element={<CompanyRevenue/>}/>
                <Route exact path="/admin/payouts" element={<AdminPayouts/>}/>
                <Route exact path="/admin/payouts/:payoutId" element={<AdminPayoutIndex/>}/>

                <Route exact path="/developer/console" element={<DeveloperConsoleIndex/>}/>

                <Route exact path="/about" element={<Contacts/>}/>
            </Routes>
            <Footer/>
        </Router>
    );
}

export default App;
